// Calcolo prezzo per listino di un articolo (stessa formula del backend: base → provvigione/ricarico → sconto, oppure prezzo fisso)
import { calculateBasePrice, calculateFinalPrice } from "./format";

export const hasVal = (v) => v !== undefined && v !== null && v !== "";
export const effPct = (map, id, def) => (hasVal(map?.[id]) ? parseFloat(map[id]) : (def || 0));
export const parseNum = (s) => parseFloat(String(s).replace(",", "."));

// Articolo attivo nel listino: listino rapido = solo spunta esplicita; listino normale = attivo salvo spunta a False o articolo "solo listini scelti"
export const plVisible = (prod, pt) => {
  const flag = prod.pricelist_active?.[pt.id];
  if (pt.quick) return flag === true;
  if (flag === true || flag === false) return flag;
  return prod.pricelist_default_active !== false;
};

export const plPricing = (prod, pt) => {
  const base = calculateBasePrice(prod.acq || 0, prod.bank || 0, prod.marg || 0, prod.extra || 0);
  const comm = effPct(prod.commission_overrides, pt.id, pt.commission);
  const disc = effPct(prod.discount_overrides, pt.id, pt.discount);
  const formula = calculateFinalPrice(base, comm, pt.markup || 0, disc);
  const fixed = prod.price_overrides?.[pt.id];
  const hasFixed = hasVal(fixed);
  const price = hasFixed ? parseFloat(fixed) : formula;
  const cost = (prod.acq || 0) * (1 + (prod.bank || 0)) + (prod.extra || 0);
  const profit = price - cost - price * comm;
  return { base, comm, disc, formula, price, hasFixed, cost, profit };
};
